import React from "react";
import { MimaText, Modal } from "../../components";
import moment from "moment";
import { amountFormatter } from "../../utils/utils";

const ViewMorePayout = ({ payout, closeModal }) => {
  return (
    <Modal closeModal={closeModal}>
      <div style={{ width: "40rem" }}>
        <MimaText variant="subtitleBold" align="center" mb={7}>
          View More Details
        </MimaText>
        <MimaText mb={2} labelTitle="Date Created">
          {moment(payout.createdAt).format("DD/MM/YYYY HH:mm a")}
        </MimaText>
        <MimaText
          mb={2}
          labelTitle="Partner Name"
        >{`${payout?.marketer?.firstname} ${payout?.marketer?.lastname}`}</MimaText>
        <MimaText mb={2} labelTitle="Total Commission">
          {amountFormatter("NGN").format(payout.totalCommission)}
        </MimaText>
        <MimaText mb={2} labelTitle="Status">
          {payout.status}
        </MimaText>

        {payout.audits.length > 0 && (
          <>
            <MimaText variant="bodyBold" align="center" mb={4}>
              Audit
            </MimaText>
            {payout?.audits?.map((audit, i) => {
              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "2rem",
                    boxSizing: "border-box",
                    marginBottom: "2rem",
                    backgroundColor: "var(--color-light)",
                  }}
                >
                  <MimaText mb={2} labelTitle="Admin Name">
                    {`${audit?.admin.firstname} ${audit?.admin.lastname}`}
                  </MimaText>
                  <MimaText
                    mb={2}
                    labelTitle="Action Performed"
                  >{`Changed Payout status to ${audit.action}`}</MimaText>
                  <MimaText mb={2} labelTitle="Action Date And Time">
                    {moment(audit?.date).format("DD/MM/YYYY HH:mm a")}
                  </MimaText>
                </div>
              );
            })}
          </>
        )}
      </div>
    </Modal>
  );
};
export default ViewMorePayout;
